export default __webpack_public_path__ + "static/media/mock-test.8c161d90.svg";